import Modal from 'react-bootstrap/Modal';

import { ModalButton } from '../../styles/StyledComponents';

const ActionInProgressModal = ({ show, closeHandler, actionHandler, message }) => {
    // ----- Actions
    const handleClose = () => {
        closeHandler();
    };

    const handleAction = () => {
        actionHandler();
    };

    // ----- Render
    return (
        <Modal show={show} backdrop='static' centered onHide={handleClose}>
            <Modal.Header className='fw-bold' closeButton>
                Mensaje de confirmación
            </Modal.Header>
            <Modal.Body>{message}</Modal.Body>
            <Modal.Footer>
                <ModalButton className='cancel' onClick={handleClose}>
                    Continuar
                </ModalButton>
                <ModalButton className='action' onClick={handleAction}>
                    Salir
                </ModalButton>
            </Modal.Footer>
        </Modal>
    );
};

export default ActionInProgressModal;
